import React, { useState, useEffect } from "react";
import { Box, Typography, Button, Chip, IconButton, Tooltip, CircularProgress, Modal, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DownloadIcon from "@mui/icons-material/Download";
import { ScheduleJobList4, ListTransFileRecs, GetMerchantProfile } from "../../util/API/batch";
import { getBaseUrl } from "../../util/utilfunctions/getbaseurl";
import { serviceUrl } from "../../config";
import { useSelector } from "react-redux";
import CustomAlert from "../UI/CustomAlert/CustomAlert";

const templateUrl = getBaseUrl(serviceUrl);
const PAYROLL_CATEGORY_ID = "33";

const getStatusConfig = (code) => {
  const map = {
    "3": { label: "Completed", color: "#d4edda", text: "#155724" },
    "0": { label: "Approved for processing", color: "#d1ecf1", text: "#0c5460" },
    "1": { label: "Approved for processing", color: "#d1ecf1", text: "#0c5460" },
    "-1": { label: "Review", color: "#fff3cd", text: "#856404" },
    "-2": { label: "Open", color: "#e2e3e5", text: "#383d41" },
    "2": { label: "Error", color: "#f5c6cb", text: "#721c24" },
    "5": { label: "Rejected", color: "#f8d7da", text: "#721c24" },
    "4": { label: "Cancelled", color: "#d6d8db", text: "#495057" },
  };
  return map[code] || { label: "Unknown", color: "#f8f9fa", text: "#333" };
};

function PayrollAdminHistoryTab() {
  const [batches, setBatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [batchRecords, setBatchRecords] = useState([]);
  const [recordsLoading, setRecordsLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [companyName, setCompanyName] = useState("Unknown Company");
  const [alert, setAlert] = useState({
    open: false,
    message: "",
    severity: "success",
    header: "Success"
  });
  // New state for total amounts
  const [batchTotals, setBatchTotals] = useState({});

  const merchantInfo = useSelector((state) => state.login.user);
  const currentUserId = merchantInfo?.id;

  console.log("current userId", currentUserId);
    useEffect(() => {
      const fetchCompanyName = async () => {
        if (currentUserId) {
          try {
            const res = await GetMerchantProfile("", currentUserId);
            console.log("GetMerchantProfile response:", JSON.stringify(res, null, 2));
  
            if (res?.callStatus === "1") {
              const businessname = res.payload?.Merchant?.businessname || "Unknown Company";
              setCompanyName(
                businessname
                  .replace(/&amp;amp;/g, "&")
                  .replace(/&amp;#039;/g, "'")
                  .replace(/&amp;#39;/g, "'")
                  .replace(/&amp;/g, "&")
                  .replace(/&quot;/g, '"')
                  .replace(/&#34;/g, "'")
                  .replace(/&#039;/g, "'")
                  .replace(/&#39;/g, "'")
                  .replace(/&lt;/g, "<")
                  .replace(/&gt;/g, ">")
                  .trim()
              );
            }
          } catch (err) {
            console.error("Failed to fetch merchant profile:", err);
          }
        }
      };
  
      fetchCompanyName();
    }, [currentUserId]);
  const fetchHistory = async () => {
    setLoading(true);
    try {
      const response = await ScheduleJobList4({
        categoryid: PAYROLL_CATEGORY_ID,
        rows: 1000,
      });

      if (response.callStatus === "1") {
        let raw = response.payload?.record || [];
        if (!Array.isArray(raw)) raw = raw ? [raw] : [];

        const mapped = raw
          .filter(item => item?.Scheduleinstance?.categoryid === PAYROLL_CATEGORY_ID)
          .map(item => {
            const s = item.Scheduleinstance;
            const recordsMatch = s.notes?.match(/records:\s*(\d+)/i);
            const totalRecords = recordsMatch ? parseInt(recordsMatch[1], 10) : 0;
            console.log("requestuserid", s.requestuserid);

            return {
              id: s.requestid,
              fileName: s.inputfilename || "—",
              records: totalRecords,
              scheduledDate: s.scheduletime || s.requesttime || "—",
              statusCode: s.executionstatus,
              notes: s.notes || "—",
              requestuserid: s.requestuserid,
              totalAmount: parseFloat(s.amount) || 0,
              totalAmountDisplay: parseFloat(s.amount)
                ? parseFloat(s.amount).toLocaleString("en-US", { minimumFractionDigits: 2 })
                : "—",
            };
          })
          .filter(batch => batch.requestuserid === currentUserId) // Only current user's batches
          .sort((a, b) => b.id - a.id);

        setBatches(mapped);
      } else {
        setBatches([]);
      }
    } catch (err) {
      console.error("Failed to load payroll history:", err);
      setAlert({
        open: true,
        severity: "error",
        header: "Load Failed",
        message: "Could not fetch batch history. Please try again."
      });
      setBatches([]);
    } finally {
      setLoading(false);
    }
  };





  useEffect(() => {
    fetchHistory();
  }, []);

  // Preload totals after batches are loaded


  const cleanNotes = (notes) =>
    notes
      ? notes

        .replace(/&amp;amp;/g, "&")
        .replace(/&amp;#039;/g, "'")
        .replace(/&amp;#39;/g, "'")

        .replace(/&amp;/g, "&")
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&nbsp;/g, " ")
        .split("\n")
        .filter(Boolean)
        .join(" • ")
      : "—";
  const cleanFileName = (fileName) => {
    if (!fileName) return "—";

    return fileName
      .replace(/&amp;#039;/g, "'")   // ✅ decode encoded apostrophe first
      .replace(/&#039;/g, "'")        // ✅ decode numeric entity
      .replace(/&#39;/g, "'")         // ✅ decode short numeric entity
      .replace(/&amp;/g, "&")         // ✅ decode &amp;
      .replace(/&/g, "_and_")         // raw & → _and_
      .replace(/[()]/g, "")           // remove parentheses
      .replace(/[^a-zA-Z0-9\s'_.-]/g, "") // ✅ ' preserved
      .replace(/\s+/g, "_")
      .replace(/_+/g, "_")
      .trim();
  };
    const getDisplayFileName = (fileName) => {
  if (!fileName) return "—";
  const fixedFileName = fileName.replace(/BATCH_-/i, "BATCH-");
  const regexPattern = companyName
    .replace(/[^a-zA-Z0-9'\s]/g, "_+")
    .replace(/'/g, "_")
    .replace(/\s+/g, "_+");

  const displayCompany = companyName
    .replace(/[^a-zA-Z0-9'\s]/g, "_")
    .replace(/\s+/g, "_");

  try {
    const regex = new RegExp(regexPattern, "i");
    const restored = fixedFileName.replace(regex, displayCompany);
    return cleanFileName(restored);
  } catch (e) {
    return cleanFileName(fixedFileName);
  }
};
  const openDetails = async (batch) => {
    setSelectedBatch(batch);
    setRecordsLoading(true);
    setModalOpen(true);

    try {
      const res = await ListTransFileRecs(batch.id);
      if (res.callStatus === "1") {
        const raw = res.payload?.record || [];
        const recordsArray = Array.isArray(raw) ? raw : raw ? [raw] : [];
        const mapped = recordsArray.map(item => item.Transfilerecs).filter(Boolean);
        setBatchRecords(mapped);
      } else {
        setBatchRecords([]);
      }
    } catch (err) {
      console.error("Failed to load batch records:", err);
      setBatchRecords([]);
    } finally {
      setRecordsLoading(false);
    }
  };

  const handleDownloadCSV = async (batchId, fileName) => {
    try {
      const res = await ListTransFileRecs(batchId);

      if (res.callStatus !== "1") {
        setAlert({
          open: true,
          severity: "error",
          header: "Download Failed",
          message: res.payload?.msg || "Failed to load records from server."
        });
        return;
      }

      const rawArray = res.payload?.record || [];
      const recordsArray = Array.isArray(rawArray) ? rawArray : rawArray ? [rawArray] : [];
      const allRecords = recordsArray.map(item => item.Transfilerecs).filter(Boolean);

      if (allRecords.length === 0) {
        setAlert({
          open: true,
          severity: "info",
          header: "No Data",
          message: "No records available to download."
        });
        return;
      }

      // Get status
      const statusCode = selectedBatch ? selectedBatch.statusCode : batches.find(b => b.id === batchId)?.statusCode;
      const statusLabel = getStatusConfig(statusCode).label;

      // ====================== TOTAL CALCULATION (Multi-currency) ======================
      const totalsByCurrency = {};

      allRecords.forEach((r) => {
        const amount = parseFloat(r.amount || 0);
        const currency = (r.currency || "CAD").toUpperCase();
        //const identifier = r.phoneno ? r.phoneno : r.email;

        if (!totalsByCurrency[currency]) totalsByCurrency[currency] = 0;
        totalsByCurrency[currency] += amount;
      });

      // Build nice total message (only when status is Completed)
      let totalMessage = "";
      if (statusCode === "3") {
        const totalParts = Object.entries(totalsByCurrency).map(([curr, total]) => {
          const formatted = total.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
          return `${formatted} ${curr}`;
        });

        totalMessage = `Total amount ${totalParts.join(" + ")} successfully deposited.`;
      }
      // ==============================================================================

      const headers = [
        "First Name", "Last Name", "Email", "Phone", "Amount", "Currency",
        "Address Line 1", "Address Line 2", "Country", "State", "Zip Code",
        "Date of Birth", "Comment", "Purpose of Account",
        "Account Add Success Message", "Fund Add Success Message"
      ];

      const rows = allRecords.map((r) => {
        const recordAmount = parseFloat(r.amount || 0).toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
        const recordCurrency = (r.currency || "CAD").toUpperCase();
        const recipientName = `${r.firstname || ""} ${r.lastname || ""}`.trim() || "Recipient";

        const identifier = r.phoneno ? r.phoneno : r.email;

        const accountMessage = r.usercreated === "0"
          ? `${identifier}@4pay.ph user already exists`
          : r.usercreated === "1"
            ? `${identifier} user created successfully`
            : "";

        return [
          (r.firstname || "").replace(/"/g, '""'),
          (r.lastname || "").replace(/"/g, '""'),
          (r.email || "").replace(/"/g, '""'),
          (r.phoneno || "").replace(/"/g, '""'),
          r.amount || "0.00",
          r.currency || "",
          (r.address1 || "").replace(/"/g, '""'),
          (r.address2 || "").replace(/"/g, '""'),
          r.country || "",
          r.state || "",
          r.zipcode || "",
          r.birthdate || "",
          (r.comment ? cleanNotes(r.comment) : "").replace(/"/g, '""'),
          (r.purposeofaccount || "").replace(/"/g, '""'),
          accountMessage.replace(/"/g, '""'),
          (r.msg || "").replace(/"/g, '""')
        ];
      });

      const csv = [headers.join(","), ...rows.map(row => row.map(cell => `"${cell}"`).join(","))].join("\n");

      // Download logic
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", `${getDisplayFileName(fileName).replace(/\.csv$/i, "")}_records.csv`);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      setAlert({
        open: true,
        severity: "success",
        header: "Download Started",
        message: "CSV file is being downloaded."
      });
    } catch (err) {
      console.error("Download failed:", err);
      setAlert({
        open: true,
        severity: "error",
        header: "Download Failed",
        message: "Error generating or saving CSV file. Please try again."
      });
    }
  };

  const refresh = () => fetchHistory();

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 10 }}>
        <CircularProgress size={60} thickness={5} />
      </Box>
    );
  }

  if (batches.length === 0) {
    return (
      <Box sx={{ textAlign: "center", py: 12, color: "#666" }}>
        <Typography variant="h6" gutterBottom>
          No payroll batch history found
        </Typography>
        <Typography variant="body2">
          Your scheduled payroll batches will appear here once submitted.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ mt: 3 }}>
      {/* Header */}
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Payroll Batch History ({batches.length} batches)
        </Typography>
        <Tooltip title="Refresh">
          <IconButton onClick={refresh} sx={{ color: "#5523D2" }}>
            <RefreshIcon />
          </IconButton>
        </Tooltip>
      </Box>

      {/* Table */}
      <TableContainer component={Paper} elevation={3}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#f8f9fa" }}>
              <TableCell><strong>Batch ID</strong></TableCell>
              <TableCell><strong>File Name</strong></TableCell>

              {/* New Total Amount Column */}
              <TableCell align="right"><strong>Total Amount</strong></TableCell>

              <TableCell><strong>Scheduled</strong></TableCell>
              <TableCell><strong>Status</strong></TableCell>
              <TableCell align="center"><strong>Actions</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {batches.map((batch) => {
              const status = getStatusConfig(batch.statusCode);

              return (
                <TableRow key={batch.id} hover sx={{ "&:hover": { backgroundColor: "#f5f5f5" } }}>
                  <TableCell><strong>#{batch.id}</strong></TableCell>
                  <TableCell sx={{ fontFamily: "monospace", fontSize: "0.9rem" }}>
                    {getDisplayFileName(batch.fileName)}
                  </TableCell>

                  {/* Total Amount Cell */}
                  <TableCell align="right" sx={{ fontWeight: 500, color: "#1976d2" }}>
                    {batch.totalAmountDisplay}
                  </TableCell>

                  <TableCell>{batch.scheduledDate}</TableCell>
                  <TableCell>
                    <Chip
                      label={status.label}
                      size="small"
                      sx={{
                        backgroundColor: status.color,
                        color: status.text,
                        fontWeight: "bold"
                      }}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <Tooltip title="View Details">
                      <IconButton onClick={() => openDetails(batch)} sx={{ color: "#5523D2" }}>
                        <VisibilityIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Download Records CSV">
                      <IconButton onClick={() => handleDownloadCSV(batch.id, batch.fileName)} sx={{ color: "#145388" }}>
                        <DownloadIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Batch Details Modal */}
      <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "95%",
            maxWidth: 1200,
            maxHeight: "90vh",
            bgcolor: "background.paper",
            boxShadow: 24,
            borderRadius: 2,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column"
          }}
        >
          <Box sx={{ p: 3, backgroundColor: "#5523D2", color: "white" }}>
            <Typography variant="h6">Batch #{selectedBatch?.id} Details</Typography>
            <Typography variant="body2">File: {getDisplayFileName(selectedBatch?.fileName)}</Typography>
            <Typography variant="body2">Records: {batchRecords.length}</Typography>
          </Box>

          <Box sx={{ flex: 1, overflow: "auto", p: 3 }}>
            {recordsLoading ? (
              <Box sx={{ display: "flex", justifyContent: "center", py: 10 }}>
                <CircularProgress />
              </Box>
            ) : batchRecords.length === 0 ? (
              <Typography textAlign="center" color="textSecondary" py={8}>
                No records found in this batch.
              </Typography>
            ) : (
              <TableContainer component={Paper}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                      <TableCell><strong>First Name</strong></TableCell>
                      <TableCell><strong>Last Name</strong></TableCell>
                      <TableCell><strong>Email</strong></TableCell>
                      <TableCell><strong>Phone</strong></TableCell>
                      <TableCell align="right"><strong>Amount</strong></TableCell>
                      <TableCell><strong>Currency</strong></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {batchRecords.map((rec, i) => (
                      <TableRow key={i}>
                        <TableCell>{rec.firstname || "—"}</TableCell>
                        <TableCell>{rec.lastname || "—"}</TableCell>
                        <TableCell>{rec.email || "—"}</TableCell>
                        <TableCell>{rec.phoneno || "—"}</TableCell>
                        <TableCell align="right">{rec.amount || "0.00"}</TableCell>
                        <TableCell>{rec.currency || "CAD"}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Box>

          <Box sx={{ p: 3, borderTop: "1px solid #eee", textAlign: "right" }}>
            <Button variant="contained" onClick={() => setModalOpen(false)}>
              Close
            </Button>
          </Box>
        </Box>
      </Modal>

      <CustomAlert
        severity={alert.severity}
        show={alert.open}
        header={alert.header}
        message={alert.message}
        onClick={() => setAlert({ ...alert, open: false })}
        autoclose={alert.severity === "success"}
      />
    </Box>
  );
}

export default PayrollAdminHistoryTab;